import './style/index.css';
import './style/print.css';
import App from './components/app';

export default App;
